import { FC } from 'react'

import styled from 'styled-components'

import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { formatDate } from 'src/Constants/formatDate'
import dayjs from 'src/Helpers/dayjs'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType, ScheduleSteps } from 'src/Types/ui'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Value = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  line-height: 150%;
`

const Label = styled.span`
  font-weight: 600;
`

export interface SpotifyScheduleReleaseDateProps {
  releaseDate: string | null
}

export const SpotifyScheduleReleaseDate: FC<
  SpotifyScheduleReleaseDateProps
> = ({ releaseDate }) => {
  const { setSearch } = useCustomSearchParams()
  const openModal = (): void => {
    setSearch({ step: ScheduleSteps.SETTINGS, modal: ModalType.ReleaseDate })
  }

  if (!releaseDate) {
    return (
      <AddParameterButton onClick={openModal}>
        Add release date
      </AddParameterButton>
    )
  }

  return (
    <Container>
      <Value>
        <Label>Release date</Label>
        <span>{dayjs.utc(releaseDate).format(formatDate.formatDate1)}</span>
      </Value>
      <PrimaryDottedButton onClick={openModal}>Edit</PrimaryDottedButton>
    </Container>
  )
}
